

import { BidiModule } from '@angular/cdk/bidi';
import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcFormPatchModule } from 'mwc/core/form';
import { MwcOutletModule } from 'mwc/core/outlet';
import { MwcIconModule } from 'mwc/icon';

import { MwcAutosizeDirective } from './autosize.directive';
import { MwcInputGroupSlotComponent } from './input-group-slot.component';
import { MwcInputGroupComponent, MwcInputGroupWhitSuffixOrPrefixDirective } from './input-group.component';
import { MwcInputDirective } from './input.directive';
import { MwcTextareaCountComponent } from './textarea-count.component';

@NgModule({
  declarations: [
    MwcTextareaCountComponent,
    MwcInputDirective,
    MwcInputGroupComponent,
    MwcAutosizeDirective,
    MwcInputGroupSlotComponent,
    MwcInputGroupWhitSuffixOrPrefixDirective
  ],
  exports: [
    MwcTextareaCountComponent,
    MwcInputDirective,
    MwcInputGroupComponent,
    MwcAutosizeDirective,
    MwcInputGroupWhitSuffixOrPrefixDirective
  ],
  imports: [BidiModule, CommonModule, MwcIconModule, PlatformModule, MwcOutletModule, MwcFormPatchModule]
})
export class MwcInputModule {}
